module.exports = __webpack_public_path__ + "img/primary.f07d5dda.png";